import { render, staticRenderFns } from "./dialog-copy-inbox-values.vue?vue&type=template&id=cead30d2&scoped=true&"
import script from "./dialog-copy-inbox-values.vue?vue&type=script&lang=js&"
export * from "./dialog-copy-inbox-values.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cead30d2",
  null
  
)

export default component.exports